import { Routes } from '@angular/router';
import { authGuard, adminGuard, studentGuard } from './core/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'verify/:certificateNo',
    loadComponent: () =>
      import('./pages/verify.component').then(m => m.VerifyComponent)
  },

  {
    path: 'admin',
    canActivate: [authGuard, adminGuard],
    loadComponent: () =>
      import('./layouts/admin-layout.component').then(m => m.AdminLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/admin-dashboard.component').then(m => m.AdminDashboardComponent)
      },
      {
        path: 'courses',
        loadComponent: () =>
          import('./pages/admin-courses.component').then(m => m.AdminCoursesComponent)
      },
      {
        path: 'schedules',
        loadComponent: () =>
          import('./pages/admin-schedules.component').then(m => m.AdminSchedulesComponent)
      },
      {
        path: 'payments',
        loadComponent: () =>
          import('./pages/admin-payments.component').then(m => m.AdminPaymentsComponent)
      },
      {
        path: 'payments/add',
        loadComponent: () =>
          import('./pages/admin-add-payment.component').then(m => m.AdminAddPaymentComponent)
      },
      {
        path: 'students',
        loadComponent: () =>
          import('./pages/admin-students.component').then(m => m.AdminStudentsComponent)
      },
      {
        path: 'certificates',
        loadComponent: () =>
          import('./pages/admin-certificates.component').then(m => m.AdminCertificatesComponent)
      }
    ]
  },

  {
    path: 'student',
    canActivate: [authGuard, studentGuard],
    loadComponent: () =>
      import('./layouts/student-layout.component').then(m => m.StudentLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/student-dashboard.component').then(m => m.StudentDashboardComponent)
      },
      {
        path: 'courses',
        loadComponent: () =>
          import('./pages/student-courses.component').then(m => m.StudentCoursesComponent)
      },
      {
        path: 'classes',
        loadComponent: () =>
          import('./pages/student-classes.component').then(m => m.StudentClassesComponent)
      },
      {
        path: 'payments',
        loadComponent: () =>
          import('./pages/student-payments.component').then(m => m.StudentPaymentsComponent)
      },
      {
        path: 'certificates',
        loadComponent: () =>
          import('./pages/student-certificates.component').then(m => m.StudentCertificatesComponent)
      },
    ]
  },



  { path: '**', redirectTo: 'login' }
];